export default Object.freeze({
  Completions: 'completions',
  Agent: 'agent',
  Responses: 'responses',
});
